import React, { useEffect, useRef } from "react";
import { useParams } from "react-router-dom";

const blogPosts = [
  {
    title: "24/7 Customer Support – We’re Here Anytime You Need Us",
    date: "27 Jun, 2025",
    content: `BookTrip4Me allows customers to enjoy a smooth booking experience without much hassle. But,
in this fast-paced technology-driven world, even machines can make mistakes...`,
  },
  {
    title: "How Can I Speak To A Live Person At American Airlines?",
    date: "25 Jun, 2025",
    content: `American Airlines is a budget-friendly carrier that offers comfortable and secure flight bookings...`,
  },
  {
    title: "How To Book Flights Instantly With BookTrip4Me",
    date: "22 Jun, 2025",
    content: `BookTrip4Me has an organised and user-friendly interface that allows an effortless booking experience...`,
  }
];

// Convert title → slug
const slugify = (text) =>
  text.toLowerCase().replace(/\s+/g, "-").replace(/[^\w-]+/g, "");

const BlogDetails = () => {
  const { slug } = useParams();
  const sectionRef = useRef(null);

  const blog = blogPosts.find((post) => slugify(post.title) === slug);

  // Scroll fade animation
  useEffect(() => {
    const el = sectionRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => entry.isIntersecting && el.classList.add("fade-visible"),
      { threshold: 0.2 }
    );
    observer.observe(el);
  }, []);

  if (!blog) {
    return (
      <div className="p-10 text-center text-red-500 font-bold text-xl">
        Blog not found.
      </div>
    );
  }

  return (
    <div
      ref={sectionRef}
      className="fade-section max-w-4xl mx-auto px-6 py-10 bg-white/80 backdrop-blur-sm rounded-3xl shadow-lg mt-10 mb-20 border border-gray-200"
    >
      {/* Title */}
      <h1 className="text-3xl md:text-4xl font-extrabold text-teal-700 leading-snug mb-3">
        {blog.title}
      </h1>

      {/* Date */}
      <p className="text-gray-500 text-sm mb-8">
        Published on <span className="font-medium">{blog.date}</span>
      </p>

      {/* Blog Body */}
      <article className="prose prose-teal max-w-none leading-relaxed text-gray-700 whitespace-pre-line">
        {blog.content}
      </article>
    </div>
  );
};

export default BlogDetails;
